import React, { useMemo } from 'react';

// Styles & Assets
import styles from './PatientAlerts.module.css';

// Components
import Tooltip from '../../UI/Tooltip/Tooltip';
import { PatientScoreAlert } from '../../Patient/PatientScoreAlert/PatientAlertElement';
import { InquiryAlertElement } from '../../Patient/PatientScoreAlert/PatientAlertElement';

// Other
import moment from 'moment';

// Interfaces
import { IPatientInquiryAlert, IPatientScoreAlert } from '../../../interfaces/Score';
import useDeletePatientAlert from '../../../hooks/useDeletePatientAlert';
interface Props {
    inquiryAlerts: IPatientInquiryAlert[] | undefined
    patientScoreAlerts: IPatientScoreAlert[] | undefined
    patientID: number
}

const PatientAlerts: React.FC<Props> = ({ inquiryAlerts = [], patientScoreAlerts = [], patientID }) => {

    const styleAlert = {
        backgroundColor: 'transparent',
        padding: 0,
        // transform: 'translateY(calc(100% + 18px))',
        width: 'fit-content'
    };

    const { handleDelete } = useDeletePatientAlert(patientID)

    const alerts = useMemo(() => {

        const newAlerts = [];

        for (const inquiryAlert of inquiryAlerts) {
            newAlerts.push({
                id: inquiryAlert.id,
                type: 'inquiry' as const,
                element: <InquiryAlertElement inquiryAlert={inquiryAlert} />,
                time: inquiryAlert.time,
            });
        }
        for (const scoreAlert of patientScoreAlerts) {
            newAlerts.push({
                id: scoreAlert.id,
                type: 'param' as const,
                element: <PatientScoreAlert scoreAlert={scoreAlert} />,
                time: scoreAlert.time,
            })
        }
        return newAlerts.sort((a, b) => a.time > b.time ? 1 : -1);

    }, [inquiryAlerts, patientScoreAlerts])


    return (
        <>{alerts.length > 0 ?
            <Tooltip
                customStyles={styleAlert}
                text={
                    <AlertTooltipElement 
                        alerts={alerts}
                        handleDelete={handleDelete}
                    />
                }
            >
                <div className={styles.circle}></div>
            </Tooltip>
            :
            <></>
        }</>
    );
};

export default PatientAlerts;

interface AlertsElementProps {
    alerts: {
        id: number;
        type: "inquiry" | 'param';
        element: JSX.Element;
        time: string;
    }[]
    handleDelete: (id: number, type: "param" | "inquiry") => (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const AlertTooltipElement: React.FC<AlertsElementProps> = ({
    alerts,
    handleDelete,
}) => {

    return (
        <div className={styles.container}>
            <div className={styles.triangle}></div>
            <div className={styles.alertsContainer}>
                {alerts.map(alert =>
                    <div key={alert.type + alert.id} className={styles.alert}>
                        <button
                            onClick={handleDelete(alert.id, alert.type)}
                            className={styles.closeButton}
                        >
                            x
                        </button>
                        {alert.element}
                        <p className={styles.timestamp}>
                            {moment(alert.time).format('DD-MM HH:mm')}
                        </p>
                    </div>
                )}
            </div>
        </div>
    )

}